import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { GroupLessonPrice, GroupPriceDisplay } from '@/types/billing'

type ApiResponse<T> = { message?: string; data?: T }

function unwrapResource<T>(raw: ApiResponse<T> | T): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as ApiResponse<T>).data as T
  }
  return raw as T
}

export type GroupPricesResponse = {
  active: GroupLessonPrice | null
  history: GroupLessonPrice[]
  /** Что показывать ученику как цену урока — настройка самой группы. */
  price_display: GroupPriceDisplay
}

export const groupPricesApi = {
  index: async (groupId: number): Promise<GroupPricesResponse> => {
    const response = await apiClient.get<ApiResponse<GroupPricesResponse>>(
      API_ENDPOINTS.GROUPS_PRICING.LESSON_PRICES(groupId),
    )
    const data = unwrapResource(response.data)
    return {
      active: data.active ?? null,
      history: Array.isArray(data.history) ? data.history : [],
      price_display: data.price_display ?? 'own_share',
    }
  },

  store: async (
    groupId: number,
    payload: { price_per_hour: number; currency?: string; effective_from?: string },
  ): Promise<GroupLessonPrice> => {
    const response = await apiClient.post<ApiResponse<GroupLessonPrice>>(
      API_ENDPOINTS.GROUPS_PRICING.LESSON_PRICES(groupId),
      payload,
    )
    return unwrapResource(response.data)
  },
}
